<template>

  <article
  v-if="article?.slug"
  class="mt-8 sm:mt-12 md:mt-0 md:flex md:items-start md:pb-4 mb-4 md:border-b-2 border-[#e8e5de] md:border-toggl group">
    <NuxtLink 
    :to="$localePath(`/articles/${article.slug}`)"
    class="block md:mr-4 md:max-w-[30%] md:flex-shrink-0"
    :aria-label="article.title"
    >
      <ImageResponsive
      v-if="article?.image"
      classes="rounded !mb-0 !md:w-[150px] md:object-cover md:h-[98px]"
      :data="article?.image"
      :xs="12"
      :sm="12"
      :md="4"
      :lg="2"
      :xl="2"
      />
    </NuxtLink>		  
    <div class="max-w-xl mt-2 md:mt-0">
      <div class="group relative">
        <NuxtLink :to="$localePath(`/articles/${article.slug}`)">
          <h3 class="text-md md:text-lg font-semibold leading-6 md:leading-6 text-gray-900">
            {{ article.title }}
          </h3>
          <div class="mt-2 flex items-center gap-x-4 text-xs">
            <time :datetime="article.date" class="text-gray-500">{{ useFormattedDate(article.date) }}</time>
          </div>
        </NuxtLink>
      </div>
    </div>
  </article>

</template>

<script setup>
const props = defineProps({
  article: {
    type: Object,
    required: true
  }
})

</script>